<template>
  <ValidationObserver ref="form" v-slot="{ invalid, passes }">
    <v-form rel="form" @submit.prevent="passes(save)">
      <v-card class="elevation-1 mb-6 rounded-lg" min-width="280" max-width="320">
        <v-card-title class="pl-7 pr-7 pt-7"> {{ title }} </v-card-title>
        <v-card-text class="pl-7 pr-7 pb-0 pt-2">
          <v-row>
            <v-col cols="12" class="ma-0 pt-1 pb-1">
              <VAutocompleteWithValidation
                v-model="status"
                label="Stav"
                rules="required"
                outlined
                dense
                background-color="white"
                :items="statuses"
                :loading="statusesLoading"
                item-text="text"
                item-value="name"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pl-7 pr-7 pb-7 pt-0">
          <v-btn type="submit" height="40px" block color="primary" depressed :loading="saving">
            Uložit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </ValidationObserver>
</template>

<script>
import { mapActions } from 'vuex'
import VAutocompleteWithValidation from '@/components/validators/VAutocompleteWithValidation'

export default {
  name: 'OrderStatusForm',
  components: { VAutocompleteWithValidation },
  props: {
    value: {
      type: Object,
    },
    title: {
      type: String,
      default: '',
    },
    all: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      status: null,
      statuses: [],
      statusesLoading: false,
      saving: false,
    }
  },
  watch: {
    value: function () {
      if (this.all) {
        this.loadStatuses()
      } else {
        this.loadTransitionStatuses()
      }
    },
  },
  async created() {
    this.statusesLoading = true
    if (this.all) {
      this.loadStatuses()
    } else {
      this.loadTransitionStatuses()
    }
  },
  methods: {
    ...mapActions({
      getOrderStatuses: 'order/getOrderStatuses',
      getOrderTransitionStatuses: 'order/getOrderTransitionStatuses',
      updateOrderStatus: 'order/updateOrderStatus',
    }),
    loadStatuses() {
      this.getOrderStatuses()
        .then((response) => {
          this.statuses = response.data
        })
        .finally(() => {
          this.statusesLoading = false
        })
    },
    loadTransitionStatuses() {
      this.getOrderTransitionStatuses(this.value.id)
        .then((response) => {
          this.statuses = response.data
        })
        .finally(() => {
          this.statusesLoading = false
        })
    },
    save() {
      this.saving = true
      this.updateOrderStatus({ id: this.value.id, status: this.status })
        .then(() => {
          this.status = null
          this.$refs.form.reset()
          this.loadStatuses()
          this.$emit('update')
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>
